var UrlHelper, m;

m = require('mithril');

UrlHelper = require('../../lib/UrlHelper');

module.exports = {
  view: function(ctrl, args) {
    var ref, selectionFilter;
    selectionFilter = (ref = args.selectionFilter) != null ? ref : function() {
      return false;
    };
    return m('.Thumbnail', [
      m('img.Thumbnail__image', {
        src: UrlHelper.getUrl(args.photo.name, 'S'),
        onclick: args.onPhotoSelect.bind(args, args.photo),
        "class": selectionFilter(args.photo) ? 'Thumbnail__image--selected' : void 0
      })
    ]);
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2FwcC9zcmMvdWkvY29tcG9uZW50cy9UaHVtYm5haWwuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL2FwcC9zcmMvdWkvY29tcG9uZW50cy9UaHVtYm5haWwuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsQ0FBQSxHQUFJLE9BQUEsQ0FBUSxTQUFSOztBQUNKLFNBQUEsR0FBWSxPQUFBLENBQVEscUJBQVI7O0FBRVosTUFBTSxDQUFDLE9BQVAsR0FBaUI7RUFDaEIsSUFBQSxFQUFNLFNBQUMsSUFBRCxFQUFPLElBQVA7QUFDTCxRQUFBO0lBQUEsZUFBQSxnREFBeUMsU0FBQTthQUFNO0lBQU47V0FDekMsQ0FBQSxDQUFFLFlBQUYsRUFBZ0I7TUFDZixDQUFBLENBQUUsc0JBQUYsRUFBMEI7UUFDekIsR0FBQSxFQUFLLFNBQVMsQ0FBQyxNQUFWLENBQWlCLElBQUksQ0FBQyxLQUFLLENBQUMsSUFBNUIsRUFBa0MsR0FBbEMsQ0FEb0I7UUFFekIsT0FBQSxFQUFTLElBQUksQ0FBQyxhQUFhLENBQUMsSUFBbkIsQ0FBd0IsSUFBeEIsRUFBOEIsSUFBSSxDQUFDLEtBQW5DLENBRmdCO1FBR3pCLENBQUEsS0FBQSxDQUFBLEVBQXVDLGVBQUEsQ0FBZ0IsSUFBSSxDQUFDLEtBQXJCLENBQWhDLEdBQUEsNEJBQUEsR0FBQSxNQUhrQjtPQUExQixDQURlO0tBQWhCO0VBRkssQ0FEVSJ9
